import * as fromDatatype from '../datatype-library/index';

export interface bl_sfa_sales_lead_label_hdr_RowInterface {
    guid:                        fromDatatype.GuidDataFieldInterface;
    guid_parent:                 fromDatatype.GuidDataFieldInterface;
    revision:                    fromDatatype.GuidDataFieldInterface;
    label_list_guid:             fromDatatype.GuidDataFieldInterface;
    level_value:                 fromDatatype.IntegerDatatypeInterface;
    txn_type:                    fromDatatype.VarcharDatatypeInterface;
    code:                        fromDatatype.VarcharDatatypeInterface;
    name:                        fromDatatype.VarcharDatatypeInterface;
    descr:                       fromDatatype.VarcharDatatypeInterface;
    status:                      fromDatatype.VarcharDatatypeInterface;
    vrsn:                        fromDatatype.VarcharDatatypeInterface;
    property_json:               fromDatatype.JsonDatatypeInterface;
    acl_config:                  fromDatatype.JsonDatatypeInterface;
    acl_policy:                  fromDatatype.JsonDatatypeInterface;
    module_guid:                 fromDatatype.GuidDataFieldInterface;
    applet_guid:                 fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid:     fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:     fromDatatype.GuidDataFieldInterface;
    created_date:                fromDatatype.TimestampTzDatatypeInterface;
    updated_date:                fromDatatype.TimestampTzDatatypeInterface;
    namespace:                   fromDatatype.VarcharDatatypeInterface;
    client_key:                  fromDatatype.VarcharDatatypeInterface;
    client_source:               fromDatatype.VarcharDatatypeInterface;
    client_value:                fromDatatype.VarcharDatatypeInterface;
}

export class  bl_sfa_sales_lead_label_hdr_RowClass implements bl_sfa_sales_lead_label_hdr_RowInterface {

    guid:                        fromDatatype.GuidDataFieldInterface;
    guid_parent:                 fromDatatype.GuidDataFieldInterface;
    revision:                    fromDatatype.GuidDataFieldInterface;
    label_list_guid:             fromDatatype.GuidDataFieldInterface;
    level_value:                 fromDatatype.IntegerDatatypeInterface;
    txn_type:                    fromDatatype.VarcharDatatypeInterface;
    code:                        fromDatatype.VarcharDatatypeInterface;
    name:                        fromDatatype.VarcharDatatypeInterface;
    descr:                       fromDatatype.VarcharDatatypeInterface;
    status:                      fromDatatype.VarcharDatatypeInterface;
    vrsn:                        fromDatatype.VarcharDatatypeInterface;
    property_json:               fromDatatype.JsonDatatypeInterface;
    acl_config:                  fromDatatype.JsonDatatypeInterface;
    acl_policy:                  fromDatatype.JsonDatatypeInterface;
    module_guid:                 fromDatatype.GuidDataFieldInterface;
    applet_guid:                 fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid:     fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:     fromDatatype.GuidDataFieldInterface;
    created_date:                fromDatatype.TimestampTzDatatypeInterface;
    updated_date:                fromDatatype.TimestampTzDatatypeInterface;
    namespace:                   fromDatatype.VarcharDatatypeInterface;
    client_key:                  fromDatatype.VarcharDatatypeInterface;
    client_source:               fromDatatype.VarcharDatatypeInterface;
    client_value:                fromDatatype.VarcharDatatypeInterface;
  
  }
  